var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { withRouter } from "react-router-dom";
import DataTree from '../../../components/UI/DataTree/DataTree';
var BrandCategoriesList = /** @class */ (function (_super) {
    __extends(BrandCategoriesList, _super);
    function BrandCategoriesList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.contextMenu = [
            {
                label: 'Редактиране',
                icon: 'fa fa-pencil-square-o',
                command: function () {
                    _this.editCategory();
                }
            },
            {
                label: 'Изтриване',
                icon: 'fa fa-trash-o',
                command: function () {
                    _this.deleteCategory();
                }
            }
        ];
        _this.contextMenuSelectedItem = null;
        _this.contextMenuItemSelected = function (id) {
            _this.contextMenuSelectedItem = id ? id : null;
        };
        _this.editCategory = function () {
            _this.props.edit(_this.contextMenuSelectedItem);
        };
        _this.deleteCategory = function () {
            _this.props.delete(_this.contextMenuSelectedItem);
        };
        return _this;
    }
    BrandCategoriesList.prototype.render = function () {
        var data = this.props.data;
        return (React.createElement(DataTree, { data: data, contextMenu: this.contextMenu, onContexMenutItem: this.contextMenuItemSelected }));
    };
    return BrandCategoriesList;
}(React.Component));
// @ts-ignore
export default withRouter(BrandCategoriesList);



//////////////////
// WEBPACK FOOTER
// ./src/components/Brands/BrandCategoriesList/BrandCategoriesList.tsx
// module id = 528
// module chunks = 0